export default "assets/images/swiper_prev-9de1738e.png";